import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Footer from '../pages/Shared/Footer';
import Navbar from '../pages/Shared/Navbar';
import BanglaUiBridge from '../i18n/BanglaUiBridge';

const Main = () => {
    const location = useLocation();
    const mobileMode = sessionStorage.getItem('posMobileMode') === 'true';
    if (mobileMode) return <Navigate to={`/mobile${location.pathname}${location.search}`} replace />;
    // const [windowWidth, setWindowWidth] = useState('')
    // const [windowHeight, setWindowHeight] = useState('')

    // const handleResize = () => {
    //     document.body.style.zoom="67%";
    //     document.body.style.height="100%"
    
        
    //   }

    //   onLoad={handleResize} style={{ width: `${windowWidth * 0.67}px`, height: `${windowHeight * 0.67}px`, }}
    return (
        <div>
            <BanglaUiBridge />
            <Navbar />
            <Outlet />
            <Footer />
        </div>
    );
};

export default Main;
